<template>
  <div>
    <loading-panel :loading="loading"></loading-panel>
<div class="row">
      <div class="col-lg-8 col-md-10 col-12 ml-auto mr-auto">

        <!-- Toolbar -->
        <div class="booking-toolbar">
          <div v-if="!incomplete_view" class="date-nav">
            <button class="date-nav__arrow" @click="prevDay" title="Previous day">
              <i class="tim-icons icon-minimal-left"></i>
            </button>
            <div class="date-nav__picker">
              <el-date-picker :editable="false"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
                :format="day_of_week + date_format_cal"
                v-model="current"
                @change="getBookings()" :picker-options="{ firstDayOfWeek: first_day_of_week }"
              >
              </el-date-picker>
            </div>
            <button class="date-nav__arrow" @click="nextDay" title="Next day">
              <i class="tim-icons icon-minimal-right"></i>
            </button>
            <button class="date-nav__today gt-pill-btn" :class="{ 'date-nav__today--active gt-pill-btn--active': isToday }" @click="goToToday">
              Today
            </button>
          </div>
          <div class="booking-toolbar__actions">
            <button v-if="!incomplete_view" class="booking-filter-btn gt-pill-btn" :class="{ 'booking-filter-btn--active gt-pill-btn--active': !show_all }" @click="toggleStatus(0)">
              Checked in
            </button>
            <button v-if="!incomplete_view" class="booking-filter-btn gt-pill-btn" :class="{ 'booking-filter-btn--active gt-pill-btn--active': show_all }" @click="toggleStatus(1)">
              All slots
            </button>
            <button class="booking-filter-btn gt-pill-btn" :class="{ 'booking-filter-btn--active gt-pill-btn--active': incomplete_view }" @click="incomplete_view ? toggleStatus(0) : getIncompleteForms()">
              Incomplete
            </button>
          </div>
        </div>

        <!-- Empty state -->
        <div v-if="empty && !loading" class="text-center mt-4 mb-3">
          <div class="font-icon-detail">
            <span style="font-size: 3em; opacity: 0.5;">
              <i class="tim-icons icon-calendar-60"></i>
            </span>
            <p class="mt-3 booking-empty-text">
              No bookings available for this date.
            </p>
          </div>
        </div>

        <!-- Booking list -->
        <div v-if="!empty && unvalidatedBookings.bookings.length > 0" class="booking-list">
          <div
            v-for="item in unvalidatedBookings.bookings"
            :key="item.id"
            class="booking-item gt-list-item"
            :class="{ 'booking-item--selected gt-list-item--selected': selectedBooking && selectedBooking.id === item.id }"
            @click="selectBooking(item)"
            tabindex="0"
            @keydown.enter="selectBooking(item)"
            @keydown.space.prevent="selectBooking(item)"
          >
            <img v-if="item.game_image_url" v-twin-src="item.game_image_url" class="booking-item__img" alt="" />
            <div v-else class="booking-item__icon">
              <i class="tim-icons icon-shape-star"></i>
            </div>
            <div class="booking-item__content">
              <div class="booking-item__header">
                <div class="booking-item__title-row">
                  <i v-if="selectedBooking && selectedBooking.id === item.id"
                     class="tim-icons icon-check-2 booking-item__check"></i>
                  <span class="booking-item__name">{{ item.game_name }}</span>
                </div>
              </div>
              <div class="booking-item__meta">
                <span v-if="item.transaction_id" class="booking-item__meta-tag text-white">
                  <i class="tim-icons icon-single-02"></i>
                  {{ item.first_name }} {{ item.last_name }}
                </span>
                <span v-else class="booking-item__meta-tag text-white">
                  <i class="tim-icons icon-single-02"></i>
                  Unbooked
                </span>
                <span class="booking-item__meta-tag text-white">
                  <i class="tim-icons icon-calendar-60"></i>
                  {{ getDate(item.booking_date) }}
                </span>
                <span class="booking-item__meta-tag text-white">
                  <i class="tim-icons icon-watch-time"></i>
                  {{ getTime(item.start_time) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Validation error -->
        <div v-if="error" class="booking-error gt-error-banner mt-3">
          <i class="tim-icons icon-alert-circle-exc"></i>
          Select a booking slot to continue
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import { API_LOCATION } from '../../../api-config'
  import { DatePicker } from 'element-ui';
  const axios = require('axios')
  import {dayOfWeek, formattedDate, time} from '../../../plugins/dateFormatter'
  import swal from "sweetalert2";

  export default {
    components: {
      [DatePicker.name]: DatePicker,
    },
    props: {
      gameInstanceId: { type: [String, Number], default: null }
    },
    data() {
      return {
        empty: false,
        loading: false,
        error: false,
        date_format: JSON.parse(localStorage.getItem('group')).date_format,
        time_format: JSON.parse(localStorage.getItem('group')).time_format,
        first_day_of_week: JSON.parse(localStorage.getItem('group')).first_day_of_week,
        date_format_cal: '',
        day_of_week: '',
        current: '',
        unvalidatedBookings: {
          bookings: []
        },
        selectedBooking: '',
        k: 0,
        show_all: 0,
        incomplete_view: false,
        bookingAutoMatched: false,
        model: {
          booking: {
            id: '',
            name: '',
            game_id: '',
            booking_time: ''

          }
        },
      };
    },
    computed: {
      isToday() {
        let now = new Date()
        let today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
        return this.current === today
      }
    },
    methods: {
      draftKey(key) {
        if (!this.gameInstanceId) {
          console.warn('draftKey called with no gameInstanceId for key:', key)
          return key + '_NONE'
        }
        return key + '_' + this.gameInstanceId
      },
      prevDay() {
        let d = new Date(this.current)
        d.setDate(d.getDate() - 1)
        this.current = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        this.getBookings()
      },
      nextDay() {
        let d = new Date(this.current)
        d.setDate(d.getDate() + 1)
        this.current = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        this.getBookings()
      },
      goToToday() {
        this.setToday()
        this.getBookings()
      },
      selectBooking(item) {
        this.selectedBooking = item
        this.bookingAutoMatched = false
        this.error = false
        this.setGame()
      },
      getDayOfWeek(d){
        if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
          return dayOfWeek(d) + ', '
        }
        return ''
      },
      async getIncompleteForms() {
        this.loading = true
        this.incomplete_view = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
          '/bookings?type=5'
        axios.get(url, config)
          .then(response => {
            this.unvalidatedBookings = response.data
            this.empty = this.unvalidatedBookings.bookings.length <= 0
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            if(err.response && err.response.status == 401){
              swal({
                title: 'Error',
                html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
                type: 'error',
              }).then((response)=> {
                this.$router.push('/')
              })
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      },
      clearSelection(){
        this.selectedBooking = ''
        this.bookingAutoMatched = false
        this.setToday()
      },
      toggleStatus(status){
        this.incomplete_view = false
        this.show_all = status
        this.getBookings()
      },
      getAuthToken() {
        return new Promise ( function(resolve) {
          Auth.currentSession()
            .then(data =>{
              resolve(data.idToken.jwtToken)
            })
            .catch(err => console.log(err))
        })
      },
      setToday(){
        let current = new Date()
        this.current = current.getFullYear() + '-' + (current.getMonth()+1) + '-' + current.getDate()
      },
      async getBookings (state) {
        if(state === 0 && JSON.parse(localStorage.getItem(this.draftKey('draft'))) && JSON.parse(localStorage.getItem(this.draftKey('draft'))).booking_date){
          this.current = JSON.parse(localStorage.getItem(this.draftKey('draft'))).booking_date.split('T')[0]
        }
        var token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings?day='
                      + this.current  + '&all=' + this.show_all + '&type=1'
        return axios.get(url, config)
          .then(response => {
            this.unvalidatedBookings = response.data
            if(this.unvalidatedBookings.bookings.length <= 0){
              this.empty = true
            } else {
              this.empty = false
            }

            this.bookingAutoMatched = false
            for(let n in this.unvalidatedBookings.bookings){
              if(JSON.parse(localStorage.getItem(this.draftKey('draft')))
                && JSON.parse(localStorage.getItem(this.draftKey('draft'))).booking_slot_id
               && JSON.parse(localStorage.getItem(this.draftKey('draft'))).booking_slot_id === this.unvalidatedBookings.bookings[n].id){
                this.selectedBooking = this.unvalidatedBookings.bookings[n]
                this.bookingAutoMatched = true
              }
            }
          })
          .catch(err => {
            console.log(err)
            if(err.response && err.response.status == 401){
              swal({
                title: 'Error',
                html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
                type: 'error',
              }).then((response)=> {
                this.$router.push('/')
              })
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      },
      isEmptyBooking(){
        if(!JSON.parse(localStorage.getItem(this.draftKey('draft'))) || JSON.parse(localStorage.getItem(this.draftKey('draft'))).booking_date){
          return false
        }
        if(this.model.booking.id.length <= 0 || this.model.booking.game_id <= 0){
          swal({
            title: 'No booking slot selected',
            text: "You must select a booking slot",
            type: 'error',
            confirmButtonColor: '#1d8cf8',
            confirmButtonText: 'OK'
          })
          return true
        }
        return false
      },
      async setBookingData () {
        if(this.selectedBooking){
          this.model.booking = this.selectedBooking
        }
        localStorage.setItem(this.draftKey('bookingInfo'), JSON.stringify(this.model))
        //check if booking id is already set and is the same as draft
        let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
        if(draft && this.selectedBooking.id === draft.booking_slot_id){
          return true
        }
        // Fallback: if the booking was auto-matched during getBookings()
        // (meaning this draft already owns this slot), skip the PUT.
        // This prevents the "already attached" error when re-opening a
        // draft after navigating away and localStorage was stale/missing.
        if(this.bookingAutoMatched){
          return true
        }
        //save draft
        let companyId = localStorage.getItem('companyId')

        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let url = API_LOCATION + 'companies/' + companyId
          + '/games/instances/' + this.gameInstanceId + '/drafts'
        let data = {
          booking_slot_id: this.model.booking.id,
          game_id: this.model.booking.game_id
        }

        return new Promise ( function(resolve) {
          axios.put(url, data, config)
            .then(response => {
              resolve(true)
            })
            .catch(err => {
              if(err.response && err.response.status == 401){
                swal({
                  title: 'Error',
                  html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
                  type: 'error',
                }).then((response)=> {
                  this.$router.push('/')
                })
              } else if(err.response && err.response.status == 409){
                // Distinct 409s from the backend. Plain string body: tracker
                // already submitted (slot reassignment blocked). JSON body
                // with error 'game_change_blocked' or 'slot_change_blocked':
                // the draft already has recorded progress for a different
                // event, so retargeting it is rejected (protects a tracker
                // that is live on another computer or tab from being silently
                // consumed by the next group's booking).
                let errBody = err.response.data
                if (typeof errBody === 'string') {
                  try { errBody = JSON.parse(errBody) } catch (e) { errBody = null }
                }
                if(errBody && errBody.error === 'game_change_blocked'){
                  swal({
                    title: 'This tracker is already in progress for another event',
                    text: "This draft has recorded progress for a different event, possibly in another tab or on another computer. Start a new tracker for this booking instead.",
                    type: 'error',
                    confirmButtonColor: '#1d8cf8',
                    confirmButtonText: 'OK'
                  })
                } else if(errBody && errBody.error === 'slot_change_blocked'){
                  swal({
                    title: 'This tracker is already in progress for another booking',
                    text: "This draft has recorded progress for a different booking of this event, possibly in another tab or on another computer. Start a new tracker for this booking instead.",
                    type: 'error',
                    confirmButtonColor: '#1d8cf8',
                    confirmButtonText: 'OK'
                  })
                } else {
                  swal({
                    title: 'This tracker has already been submitted',
                    text: "To record a new game, start a fresh tracker from the beginning.",
                    type: 'info',
                    confirmButtonColor: '#1d8cf8',
                    confirmButtonText: 'OK'
                  })
                }
                resolve(false)
              } else if(err.response && err.response.status == 500){
                swal({
                  title: 'This booking slot is already attached to another draft',
                  text: "Delete the draft or select another booking slot",
                  type: 'error',
                  confirmButtonColor: '#1d8cf8',
                  confirmButtonText: 'OK'
                })
                resolve(false)
              }
            })
        })


      },
      getDate(d){
        return this.getDayOfWeek(d) + formattedDate(this.date_format, d)
      },
      getTime(d){
        return time(this.time_format, d)
      },
      async setGame () {
        this.model.booking = this.selectedBooking
      },
      validate() {
        if(this.selectedBooking){
          this.error = false
          return true
        }
        this.error = true
        return false
      }
    },
    mounted () {
      this.date_format_cal = this.date_format
      this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
      this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
      if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
        this.day_of_week = 'ddd, '
      }
      this.setToday()
      this.getBookings()
    }
  };
</script>

<style scoped>
/* ========================================
   Toolbar
   ======================================== */
.booking-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.booking-toolbar__actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

/* ========================================
   Date navigator
   ======================================== */
.date-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.date-nav__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.date-nav__arrow i {
  font-size: 11px;
}

.date-nav__arrow:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  border-color: rgba(255, 255, 255, 0.2);
}

.date-nav__picker {
  width: 180px;
}

/* Today button — visual base from gt-pill-btn */
.date-nav__today {
  margin-left: 4px;
}

/* Filter buttons — visual base from gt-pill-btn */
.booking-filter-btn i {
  font-size: 10px;
}

/* ========================================
   Booking list
   ======================================== */
.booking-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ========================================
   Booking item — layout only (visual base from gt-list-item)
   ======================================== */
.booking-item {
  display: flex;
  align-items: center;
  gap: 14px;
}

/* ========================================
   Game image
   ======================================== */
.booking-item__img {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ========================================
   Icon placeholder
   ======================================== */
.booking-item__icon {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.25);
  font-size: 18px;
}

/* ========================================
   Content layout
   ======================================== */
.booking-item__content {
  flex: 1;
  min-width: 0;
}

.booking-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.booking-item__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.booking-item__check {
  color: #e14eca;
  font-size: 13px;
  flex-shrink: 0;
}

.booking-item__name {
  font-size: 15px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.booking-item--selected .booking-item__name {
  color: #e14eca;
}

/* ========================================
   Metadata tags
   ======================================== */
.booking-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
}

.booking-item__meta-tag {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.booking-item__meta-tag i {
  font-size: 11px;
}

/* ========================================
   Empty state
   ======================================== */
.booking-empty-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

/* ========================================
   Responsive
   ======================================== */
@media (max-width: 576px) {
  .booking-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .booking-toolbar__actions {
    justify-content: flex-end;
  }

  .booking-item__meta {
    gap: 6px;
  }

  .booking-item__meta-tag {
    font-size: 11px;
  }
}
</style>

<!-- Date picker + light mode overrides (unscoped) -->
<style>
/* Date picker compact sizing */
.date-nav__picker .el-date-editor {
  width: 100% !important;
}

.date-nav__picker .el-date-editor .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 11px;
  font-weight: 500;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  padding-left: 28px;
}

.date-nav__picker .el-date-editor .el-input__inner:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

.date-nav__picker .el-date-editor .el-input__inner:focus {
  border-color: #e14eca;
}

.date-nav__picker .el-date-editor .el-input__prefix {
  left: 8px;
  top: 0;
  height: 30px;
  line-height: 30px;
}

.date-nav__picker .el-date-editor .el-input__prefix i {
  font-size: 12px;
  line-height: 30px;
  color: rgba(255, 255, 255, 0.4);
}

.date-nav__picker .el-date-editor .el-input__suffix {
  top: 0;
  height: 30px;
  line-height: 30px;
}

.date-nav__picker .el-date-editor .el-input__suffix i {
  line-height: 30px;
  font-size: 11px;
}

/* Date picker light mode */
.white-content .date-nav__picker .el-date-editor .el-input__inner {
  background: transparent;
  border-color: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.5);
}

.white-content .date-nav__picker .el-date-editor .el-input__inner:hover {
  border-color: rgba(0, 0, 0, 0.18);
}

.white-content .date-nav__picker .el-date-editor .el-input__inner:focus {
  border-color: #e14eca;
}

.white-content .date-nav__picker .el-date-editor .el-input__prefix i {
  color: rgba(0, 0, 0, 0.35);
}

/* Light mode — sub-element overrides (base/hover/selected handled by gt-list-item) */
.white-content .booking-item__name {
  color: #344675;
}

.white-content .booking-item--selected .booking-item__name {
  color: #e14eca;
}

.white-content .booking-item__meta-tag {
  color: rgba(0, 0, 0, 0.45);
}

.white-content .booking-item__img {
  border-color: rgba(0, 0, 0, 0.1);
}

.white-content .booking-item__icon {
  background: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.2);
}

.white-content .date-nav__arrow {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.5);
}

.white-content .date-nav__arrow:hover {
  background: rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.75);
  border-color: rgba(0, 0, 0, 0.18);
}

/* Today + filter pill button light mode handled by gt-pill-btn */

.white-content .booking-empty-text {
  color: rgba(0, 0, 0, 0.5);
}

</style>
